import { useMemo } from "react";
import LessonInProgressBanner from "../components/LessonInProgressBanner";

/**
 * Test-only probe route used by the QA/Playwright harness to verify
 * the LessonInProgressBanner across deterministic startedAt offsets.
 * Read query params: ?variant=generate|refine&offset_seconds=46
 * The component computes startedAt = Date.now() - offset_seconds * 1000.
 *
 * This route is wired in App.js at /__banner_probe and is NOT linked
 * from any production surface. Safe to leave in or remove.
 */
const BannerProbe = () => {
  const params = new URLSearchParams(window.location.search);
  const variant = params.get("variant") === "refine" ? "refine" : "generate";
  const offset = parseInt(params.get("offset_seconds") || "0", 10);
  const startedAt = useMemo(() => Date.now() - offset * 1000, [offset]);
  return (
    <div data-testid="banner-probe-root" style={{ padding: 24, maxWidth: 720 }}>
      <p data-testid="banner-probe-meta">
        variant={variant} offset_seconds={offset}
      </p>
      <LessonInProgressBanner variant={variant} startedAt={startedAt} />
    </div>
  );
};

export default BannerProbe;
